import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { LANGUAGES } from '@/i18n/languages';
import { markManualLanguage } from '@/i18n/manualLanguage';
import { Select, SelectOption } from '@/components/ui';

interface LanguageSwitcherProps {
  /** Compact mode (narrower trigger) for sidebar use. */
  compact?: boolean;
}

export function LanguageSwitcher({ compact = false }: LanguageSwitcherProps) {
  const { i18n, t } = useTranslation();
  const current = (i18n.language || 'en').split('-')[0];

  const options: SelectOption[] = useMemo(
    () =>
      LANGUAGES.map((l) => ({
        value: l.code,
        label: l.nativeName,
        hint: compact ? undefined : l.englishName,
        prefix: (
          <span aria-hidden role="img" className="text-base leading-none">
            {l.flag}
          </span>
        ),
        searchAliases: [l.englishName, l.code],
      })),
    [compact],
  );

  return (
    <Select
      value={current}
      onChange={(v) => {
        markManualLanguage();
        void i18n.changeLanguage(v);
      }}
      options={options}
      ariaLabel={t('common.language')}
      width="auto"
      className={compact ? 'text-xs py-1 min-w-[7rem]' : 'min-w-[10rem]'}
    />
  );
}
